<template lang="pug">
article-list-page-template.px-lg-15(
  :title="pageTitle",
  :loading="loading",
  no-data-text="Nenhum boletim disponível."
)
  template(#items)
    covid-card.mb-3.white--text(
      v-for="({ img, title, scheduled, to }, i) in items",
      :key="i",
      :img="img",
      :title="title",
      :date="scheduled",
      :to="to",
      large
    )
  template(#side)
    communications-widget
</template>

<script>
import ArticleListPageTemplate from "@/components/templates/ArticleListPage.vue";
import CovidCard from "@/components/cards/Covid";
import CommunicationsWidget from "@/components/widgets/Communications";
import { formatToURL } from "@/components/utils.js";

const _config = {
  mod: "covid",
  title: "BOLETIM CORONAVIRUS",
  path: "/boletim-coronavirus",
};

export default {
  data: () => ({
    pageTitle: _config.title,
    loading: true,
    totalItems: 0,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(
        ({ id, title, img, scheduled }) => ({
          title,
          img: this.files + img,
          scheduled,
          to: `${_config.path}/${formatToURL(title)}-${id}`,
        })
      );
    },
  },
  methods: {
    getItems() {
      this.loading = true;

      this.$rest(_config.mod)
        .get({
          keepCache: true,
        })
        .then(() => (this.loading = false));
    },
  },
  watch: {
    page() {
      this.getItems();
    },
  },
  created() {
    this.getItems();
  },
  components: {
    ArticleListPageTemplate,
    CovidCard,
    CommunicationsWidget,
  },
};
</script>
